import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Importera useParams och useNavigate
import "../App.css";
//import { saveForm } from '../db';
import { db } from "../firebase"; // Importera Firestore
import {
  collection,
  addDoc,
  serverTimestamp,
  getDoc,
  doc,
  updateDoc,
} from "firebase/firestore"; // Korrekt import
import { getAuth } from "firebase/auth";
import InfoModal from "./InfoModal";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

const FormBuilder = () => {
  const auth = getAuth();
  const tenantId = getTenantIdFromHost();
  const { surveyId } = useParams(); // Hämta surveyId från URL
  const navigate = useNavigate(); // För navigering efter sparande
  const [formName, setFormName] = useState("");
  const [questions, setQuestions] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [editing, setEditing] = useState(false);

  const [showCloseModal, setShowCloseModal] = useState(false);
  const [infoTitle, setInfoTitle] = useState("");
  const [infoText, setInfoText] = useState("");
  const [btn1Text, setBtn1Text] = useState("");
  const [btn2Text, setBtn2Text] = useState("");

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const [createdAt, setCreatedAt] = useState(formatDate(Date.now())); // Nytt tillstånd för att lagra skapad datum

  // Hämta formulär om vi ska redigera ett existerande formulär
  useEffect(() => {
    if (surveyId) {
      setEditing(true);
      fetchFormData(surveyId);
    } else {
      setEditing(false);
      resetForm();
    }
  }, [surveyId]);

  // Förhindra Enter från att trigga submit när användaren inte är på knappen
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.type !== "submit") {
      e.preventDefault(); // Förhindra Enter om det inte är submit-knappen
    }
  };

  const fetchFormData = async (surveyId) => {
    const docRef = doc(db, "tenants", tenantId, "forms", surveyId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const formData = docSnap.data();
      setFormName(formData.formName);
      setQuestions(formData.questions);
      setCreatedAt(formData.createdAt.toDate());
    }
  };

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  const PreviewForm = ({ formName, questions }) => {
    return (
      <div className="previewWrapper">
        <h3>Förhandsgranska formulär: {formName}</h3>
        <ul>
          {questions.map((q, index) => (
            <li key={index} className="questionDevider">
              <strong>{q.text}</strong>
              {q.type === "radio" || q.type === "checkbox" ? (
                <ul>
                  {q.options.map((option, i) => (
                    <li key={i}>{option}</li>
                  ))}
                </ul>
              ) : q.type === "scale" ? (
                <p>
                  Skala: {q.scaleMin} - {q.scaleMax}
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const addQuestion = () => {
    setQuestions([
      ...questions,
      {
        text: "",
        type: "text",
        options: [],
        scaleMin: 0,
        scaleMax: 10,
        allowComment: false,
        commentLabel: "",
      },
    ]);
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index].text = value;
    setQuestions(newQuestions);
  };

  const handleTypeChange = (index, type) => {
    const newQuestions = [...questions];
    newQuestions[index].type = type;

    // Om frågetypen ändras till "text", rensa alternativ
    if (type === "text") {
      newQuestions[index].options = []; // Rensa alternativ om typ är text
    }
    if (type === "scale") {
      newQuestions[index].options = []; // Rensa alternativ om typ är text
    }
    setQuestions(newQuestions);
  };

  const handleOptionChange = (index, optionIndex, value) => {
    const newQuestions = [...questions];
    newQuestions[index].options[optionIndex] = value;
    setQuestions(newQuestions);
  };

  const addOption = (index) => {
    const newQuestions = [...questions];
    newQuestions[index].options.push("");
    setQuestions(newQuestions);
  };

  const removeOption = (questionIndex, optionIndex) => {
    const newQuestions = [...questions];
    newQuestions[questionIndex].options.splice(optionIndex, 1); // Ta bort alternativet
    setQuestions(newQuestions);
  };

  const handleScaleChange = (index, value, minOrMax) => {
    const newQuestions = [...questions];
    if (minOrMax === "min") {
      newQuestions[index].scaleMin = value;
    } else if (minOrMax === "max") {
      newQuestions[index].scaleMax = value;
    }
    setQuestions(newQuestions);
  };

  const removeQuestion = (index) => {
    const newQuestions = questions.filter((_, i) => i !== index);
    setQuestions(newQuestions);
  };

  const moveQuestion = (index, direction) => {
    const newQuestions = [...questions];
    const [movedQuestion] = newQuestions.splice(index, 1); // Ta bort frågan
    const newIndex = direction === "up" ? index - 1 : index + 1; // Bestäm ny index baserat på riktningen
    newQuestions.splice(newIndex, 0, movedQuestion); // Sätt tillbaka frågan på nytt index
    setQuestions(newQuestions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formName.trim()) {
      setInfoTitle("!");
      setInfoText("Du behöver fylla i ett namn på formuläret");
      setBtn1Text("Ok!");
      setBtn2Text(null);
      setShowCloseModal(true);
      //alert("Please enter a form name");
      return;
    }

    const invalidQuestions = questions.filter((q) => !q.text.trim());
    if (invalidQuestions.length > 0 || !questions.length) {
      setInfoTitle("!");
      setInfoText("Formuläret måste ha frågor");
      setBtn1Text("Ok!");
      setBtn2Text(null);
      setShowCloseModal(true);
      //alert("Please fill in all question texts.");
      return;
    }

    const invalidOptions = questions.filter(
      (q) =>
        (q.type === "radio" || q.type === "checkbox") && q.options.length === 0,
    );
    if (invalidOptions.length > 0) {
      setInfoTitle("!");
      setInfoText(
        "Du behöver lägga till svarsalternativ till radioknappar och checkboxar",
      );
      setBtn1Text("Ok!");
      setBtn2Text(null);
      setShowCloseModal(true);
      //alert("Please add options to all radio or checkbox questions.");
      return;
    }

    //saveForm({ formName, questions });
    // Spara formuläret i Firestore
    try {
      if (editing) {
        // Om vi redigerar ett formulär, uppdatera det
        const docRef = doc(db, "tenants", tenantId, "forms", surveyId);
        await updateDoc(docRef, {
          formName,
          questions,
          updatedAt: serverTimestamp(), // Lägg till en uppdaterad tidsstämpel
        });
        setInfoTitle("✓");
        setInfoText("Formuläret har sparats");
        setBtn1Text(null);
        setBtn2Text("Ok!");
        setShowCloseModal(true);

        //alert("Form updated successfully!");
        //navigate(`/survey/${docRef.id}`); // Navigera till formuläret för att fylla i det
      } else {
        // Om vi skapar ett nytt formulär
        const docRef = await addDoc(
          collection(db, "tenants", tenantId, "forms"),
          {
            formName,
            questions,
            createdAt: serverTimestamp(),
            createdBy: auth.currentUser?.email || "unknown",
           // responsesCount: 0,
          },
        );

        // Hämta dokumentet efter att det skapats
        const docSnap = await getDoc(docRef);
        const createdDate = docSnap.data().createdAt.toDate(); // Konvertera till JavaScript Date
        setCreatedAt(createdDate);

        setInfoTitle("✓");
        setInfoText("Formuläret har sparats");
        setBtn1Text(null);
        setBtn2Text("Ok!");
        setShowCloseModal(true);

        //alert("Form saved successfully!");
        //navigate(`/survey/${docRef.id}`); // Navigera till formuläret för att fylla i det
      }
      resetForm();
    } catch (error) {
      console.error("Error saving form: ", error);
    }
  };

  const handleAllowCommentChange = (index, checked) => {
    const newQuestions = [...questions];
    newQuestions[index].allowComment = checked;

    if (!checked) {
      newQuestions[index].commentLabel = "";
    }

    setQuestions(newQuestions);
  };

  const handleCommentLabelChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index].commentLabel = value;
    setQuestions(newQuestions);
  };
  const resetForm = () => {
    setFormName("");
    setQuestions([]);
    setCreatedAt(null);
    setEditing(false);
  };
  const doCloseForm = () => {
    resetForm();
    navigate(`/survey`);
  };

  return (
    <>
      <div className="formBuilderWrapper">
        {editing ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1>Redigera undersökning</h1>
            <button className="closeButton" onClick={doCloseForm}></button>
          </div>
        ) : (
          <h1>Skapa en undersökning</h1>
        )}

        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
          <div className="questionDevider">
            <h4>Namn på undersökningen</h4>
            <input
              type="text"
              value={formName}
              onChange={(e) => setFormName(e.target.value)}
              placeholder="Namn på undersökningen"
            />
            {createdAt && <h4>Skapad: {createdAt.toLocaleString()}</h4>}{" "}
            {/* Visa skapad datum */}
          </div>
          {questions.map((q, index) => (
            <div key={index} className="questionDevider">
              <p>{`Fråga ${index + 1}`}</p>
              <div>
                <textarea
                  rows="4"
                  cols="80"
                  type="text"
                  value={q.text}
                  onChange={(e) => handleQuestionChange(index, e.target.value)}
                  placeholder={`Fråga ${index + 1}`}
                />
              </div>
              <h4>Typ av fråga</h4>
              <div>
                <select
                  onChange={(e) => handleTypeChange(index, e.target.value)}
                  value={q.type}
                >
                  <option value="text">Textfråga (fritext)</option>
                  <option value="radio">Radioknappar (ett alternativ)</option>
                  <option value="checkbox">
                    Checkboxar (flera alternativ)
                  </option>
                  <option value="scale">Skala</option>{" "}
                  {/* Lägg till alternativ för sifferskala */}
                </select>
              </div>

              {q.type === "radio" || q.type === "checkbox" ? (
                <div>
                  <h4>Alternativ</h4>
                  {q.options.map((option, optionIndex) => (
                    <div key={optionIndex}>
                      <input
                        className="halfInput"
                        type="text"
                        value={option}
                        onChange={(e) =>
                          handleOptionChange(index, optionIndex, e.target.value)
                        }
                        placeholder={`Alternativ ${optionIndex + 1}`}
                      />
                      <button
                        className="deleteButton"
                        type="button"
                        onClick={() => removeOption(index, optionIndex)}
                      >
                        x
                      </button>{" "}
                      {/* Ta bort alternativ */}
                    </div>
                  ))}
                  <button
                    className="addButton"
                    type="button"
                    onClick={() => addOption(index)}
                  >
                    Skapa alternativ
                  </button>
                  <div style={{ marginTop: "1em" }}>
                    <label>
                      <input
                        type="checkbox"
                        checked={q.allowComment || false}
                        onChange={(e) =>
                          handleAllowCommentChange(index, e.target.checked)
                        }
                      />
                      Tillåt kompletterande fritext
                    </label>

                    {q.allowComment && (
                      <div style={{ marginTop: "0.5em" }}>
                        <input
                          type="text"
                          value={q.commentLabel || ""}
                          onChange={(e) =>
                            handleCommentLabelChange(index, e.target.value)
                          }
                          placeholder="T.ex. Vill du berätta lite mer? (valfritt)"
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : null}

              {q.type === "scale" ? (
                <div>
                  <h4>Ange skala (min, max)</h4>
                  <input
                    type="number"
                    value={q.scaleMin}
                    onChange={(e) =>
                      handleScaleChange(index, e.target.value, "min")
                    }
                    placeholder="Min"
                    min="0"
                  />
                  <input
                    type="number"
                    value={q.scaleMax}
                    onChange={(e) =>
                      handleScaleChange(index, e.target.value, "max")
                    }
                    placeholder="Max"
                    min="1"
                  />
                  <p>
                    Skala: {q.scaleMin} - {q.scaleMax}
                  </p>
                </div>
              ) : null}

              {/* Radera och flytta frågor */}
              <div className="moveBtnWrapper">
                {index > 0 && (
                  <button
                    className="moveButton"
                    type="button"
                    onClick={() => moveQuestion(index, "up")}
                  >
                    <i className="arrow up"></i>
                  </button>
                )}
                {index < questions.length - 1 && (
                  <button
                    className="moveButton"
                    type="button"
                    onClick={() => moveQuestion(index, "down")}
                  >
                    <i className="arrow down"></i>
                  </button>
                )}
              </div>
              <div className="deleteBtnWrapper">
                <button
                  className="deleteButton"
                  type="button"
                  onClick={() => removeQuestion(index)}
                >
                  x
                </button>
              </div>
            </div>
          ))}
          <button className="addButton" type="button" onClick={addQuestion}>
            Skapa Fråga
          </button>
          <button type="submit">
            {editing ? "Uppdatera Formulär" : "Spara Formulär"}
          </button>
        </form>
        <div className="questionDevider"></div>
        {!showPreview ? (
          <button type="button" onClick={togglePreview}>
            Förhandsgranskning
          </button>
        ) : (
          <button className="closeButton" onClick={togglePreview}></button>
        )}
        {showPreview && (
          <PreviewForm formName={formName} questions={questions} />
        )}
      </div>
      {showCloseModal && (
        <InfoModal
          onCancel={() => setShowCloseModal(false)}
          onConfirm={() => {
            setShowCloseModal(false);
            doCloseForm();
          }}
          btn1={btn1Text}
          btn2={btn2Text}
        >
          <h3>{infoTitle}</h3>
          <p>{infoText}</p>
        </InfoModal>
      )}
    </>
  );
};

export default FormBuilder;
